import { useCallback, useContext } from 'react';
import ConditionalTile, {
  type ConditionalTileData
} from '@/ConditionalTiles/ConditionalTile';
import SearchSource from '~/constants/SearchSource';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useIsMobile } from '~/contexts/DeviceContext';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';
import { TooltipAnalytics } from '~/utilities/Analytics/TooltipAnalytics';
import ClickableTile from './ClickableTile';

export default function KeepMovingTile() {
  const isMobile = useIsMobile();
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { setAppliedFilters } = useContext(AppliedFiltersContext);

  const eventTracker = TooltipAnalytics('Great Deal');

  const data: ConditionalTileData = {
    content: {
      heading1: 'Save $1,500+ with these great deals',
      subHeading:
        'Browse cars that save you $1,500 or more vs. Kelley Blue Book® Typical Listing Price. '
    },
    button: 'Shop Now',
    tooltip: {
      strong: 'Great Deal',
      text: 'Savings amount based on the difference between Kelley Blue Book® Typical Listing Price and current Carvana listing price, not including tax, title, registration, or delivery charges. Savings amounts are updated daily.'
    }
  };

  const styles = {
    background: `linear-gradient(180deg, rgba(24, 53, 88, 0.65) 0%, rgba(24, 53, 88, 0) 100%), url(${process.env.CVNA_APP_ASSETS_CDN}/serenity-ui/images/keep-moving-tile.jpg)`,
    backgroundSize: 'cover',
    backgroundPositionY: '94%'
  };

  const onClick = useCallback<React.MouseEventHandler>(
    ev => {
      ev.preventDefault();

      setAppliedFilters({
        tagIds: ['104']
      });

      setSearchSource(SearchSource.Tile);
    },
    [setAppliedFilters, setSearchSource]
  );

  return (
    <ClickableTile
      tileId="GreatDealTile"
      link="/cars?cvnaid=eyJmaWx0ZXJzIjp7InRhZ0lkcyI6WzEwNF19fQ=="
      name="GreatDealTile"
      backgroundLink={`${process.env.CVNA_APP_ASSETS_CDN}/serenity-ui/images/keep-moving-tile.jpg`}
      handleBackground="bottom"
      bgOffsetY="94%"
      darkenBackground
      experiment
      handleTileClick={onClick}
      styles={styles}
      smallerSize={isMobile}
    >
      <ConditionalTile
        light
        top
        hasButton
        hideIcon
        backgroundButton
        showTooltip
        event={eventTracker}
        isMobile={isMobile}
        data={data}
      />
    </ClickableTile>
  );
}
